import React, { useEffect } from "react"
// Formik Validation
import * as Yup from "yup"
import { useFormik } from "formik"

import logoDark from "../../assets/images/logo-dark.png"
import logoLight from "../../assets/images/logo-dark.png"

// action
import { registerUser, apiError } from "../../store/actions"

//redux
import { useSelector, useDispatch } from "react-redux"
import { createSelector } from "reselect"

import { Link, useNavigate } from "react-router-dom"
import {
  Alert,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
} from "reactstrap"
import MailOutlineIcon from "@mui/icons-material/MailOutline"
import PasswordIcon from "@mui/icons-material/Password"
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined"
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined"
import PropTypes from "prop-types"
import { IntroScreen } from "./intro-screen"
const Register = props => {
  //meta title
  document.title = "Register | Skote - React Admin & Dashboard Template"

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      email: "",
      username: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Please Enter Your Email"),
      username: Yup.string().required("Please Enter Your Username"),
      password: Yup.string().required("Please Enter Your Password"),
    }),
    onSubmit: values => {
      dispatch(registerUser(values))
    },
  })

  const selectAccountState = state => state.Account
  const AccountProperties = createSelector(selectAccountState, account => ({
    user: account.user,
    registrationError: account.registrationError,
    success: account.success,
    // loading: account.loading,
  }))
  const [showPassword, setShowPassword] = React.useState(false)
  const {
    user,
    registrationError,
    success,
    // loading
  } = useSelector(AccountProperties)

  useEffect(() => {
    dispatch(apiError(""))
  }, [dispatch])

  useEffect(() => {
    success && setTimeout(() => navigate("/login"), 2000)
  }, [success, navigate])

  return (
    <React.Fragment>
      <Container fluid className="min-vh-100 d-flex flex-column">
        <Row className="flex-grow-1">
          {/* Left Intro (hidden on small screens) */}
          <Col
            lg={6}
            className="d-none d-lg-flex align-items-center justify-content-center bg-light"
            style={{
              backgroundImage: "url('/background-pattern.svg')",
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <IntroScreen
              title1="Feedback Informed."
              title2="Performance Optimized."
              subtitle="Empower decisions with actionable intelligence."
            />
          </Col>

          {/* Right Form */}
          <Col
            xs={12}
            lg={6}
            className="d-flex align-items-center justify-content-center p-4"
          >
            <div style={{ width: "100%", maxWidth: "420px" }}>
              <Card className="shadow-sm">
                <CardBody>
                  <div className="text-center mb-4">
                    <Link to="/" className="d-inline-block">
                      <img
                        src={logoDark}
                        alt="logo-dark"
                        height="30"
                        className="auth-logo-dark"
                      />
                      <img
                        src={logoLight}
                        alt="logo-light"
                        height="30"
                        className="auth-logo-light"
                      />
                    </Link>
                  </div>

                  <h4 className="text-center mb-2">Free Register</h4>
                  <p className="text-muted text-center mb-4">
                    Get your free Lexa account now.
                  </p>

                  <Form
                    className="form-horizontal"
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                  >
                    {user ? (
                      <Alert color="success">Register User Successfully</Alert>
                    ) : null}
                    {registrationError ? (
                      <Alert color="danger">{registrationError}</Alert>
                    ) : null}

                    {/* Email */}
                    <div className="mb-3 position-relative">
                      <Label htmlFor="email">Email</Label>
                      <div className="position-relative">
                        <MailOutlineIcon
                          className="position-absolute"
                          style={{
                            left: "10px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            color: "#9ca3af",
                          }}
                        />
                        <Input
                          id="email"
                          name="email"
                          className="form-control ps-5"
                          placeholder="Enter email"
                          type="email"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                          invalid={
                            validation.touched.email && validation.errors.email
                              ? true
                              : false
                          }
                        />
                        {validation.touched.email && validation.errors.email ? (
                          <FormFeedback>{validation.errors.email}</FormFeedback>
                        ) : null}
                      </div>
                    </div>

                    {/* Username */}
                    <div className="mb-3">
                      <Label htmlFor="username">Username</Label>
                      <Input
                        id="username"
                        name="username"
                        placeholder="Enter username"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.username || ""}
                        invalid={
                          validation.touched.username &&
                          validation.errors.username
                            ? true
                            : false
                        }
                      />
                      {validation.touched.username &&
                      validation.errors.username ? (
                        <FormFeedback>
                          {validation.errors.username}
                        </FormFeedback>
                      ) : null}
                    </div>

                    {/* Password */}
                    <div className="mb-3 position-relative">
                      <Label htmlFor="password">Password</Label>
                      <div className="position-relative">
                        <PasswordIcon
                          className="position-absolute"
                          style={{
                            left: "10px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            color: "#9ca3af",
                          }}
                        />
                        <Input
                          id="password"
                          name="password"
                          className="form-control ps-5 pe-5"
                          type={showPassword ? "text" : "password"}
                          placeholder="Enter Password"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.password || ""}
                          invalid={
                            validation.touched.password &&
                            validation.errors.password
                              ? true
                              : false
                          }
                        />
                        <span
                          onClick={() => setShowPassword(!showPassword)}
                          className="position-absolute"
                          style={{
                            right: "10px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                            color: "#9ca3af",
                          }}
                        >
                          {showPassword ? (
                            <VisibilityOutlinedIcon />
                          ) : (
                            <VisibilityOffOutlinedIcon />
                          )}
                        </span>
                        {validation.touched.password &&
                        validation.errors.password ? (
                          <FormFeedback>
                            {validation.errors.password}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </div>

                    {/* Submit */}
                    <div className="d-grid">
                      <button
                        className="btn btn-primary waves-effect waves-light"
                        type="submit"
                      >
                        Register
                      </button>
                    </div>

                    {/* Terms */}
                    <p className="text-muted text-center mt-3 mb-0">
                      By registering you agree to the Lexa{" "}
                      <Link to="#" className="text-primary">
                        Terms of Use
                      </Link>
                    </p>
                  </Form>
                </CardBody>
              </Card>

              {/* Already have account */}
              <div className="text-center mt-4">
                <p>
                  Already have an account?{" "}
                  <Link to="/login" className="text-primary">
                    Login
                  </Link>
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  )
}

export default Register
